import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/nlp/accurate_nlp.webp";

function Nlpaccurate() {
  return (
    <section
      className="streamline_cloud blockchain_future"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={7} lg={7} xl={7} xxl={7}>
            <h2>
              Deploy High-Performing NLP Solutions for More{" "}
              <span>Accurate Predictions & Process Automation</span>
            </h2>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
               Let’s Build Custom NLP
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Nlpaccurate;
